/* eslint-disable linebreak-style */
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  Divider,
} from '@material-ui/core';
import { t } from '../../../../i18n';

const useStyles = makeStyles(() => ({
  container: {
    width:'100%',
    textAlign:'center',
    color:'grey' 
  },
}));

const ExpozorHeader = props => {
 
  const classes = useStyles();
  return (
    <div>
      <Card
        className={classes.alignButton }
      >
        <Divider />
        <CardContent className={classes.container}>
          <div><h5>{t('expozor.headerTitle')}</h5></div>
        </CardContent>
      </Card>
    </div>
  );
}

ExpozorHeader.propTypes = {
  className: PropTypes.string,
};


export default withRouter(ExpozorHeader);
